import React from "react";
import "./FeedbackButtons.css";
import HappyIconDark from "../../assets/icons/HappyIconDark.svg";
import HappyIconLight from "../../assets/icons/HappyIconLight.svg";
import UnhappyIconDark from "../../assets/icons/UnhappyIconDark.svg";
import UnhappyIconLight from "../../assets/icons/UnhappyIconLight.svg";
import { strings } from "../../translations/strings";
import { api_endpoint } from "../../config/environment";

const FeedbackButtons = ({
  isDarkMode,
  colors,
  type,
  isPressed,
  setIsPressed,
}) => {
  const buttonPress = ({ helpfull }) => {
    setIsPressed(true);
    const endpoint = `${api_endpoint}ai/helpfull`;
    const formData = new FormData();
    formData.append("helpfull", helpfull);
    formData.append("type", type);
    const requestOptions = {
      method: "POST",
      body: formData,
    };
    fetch(endpoint, requestOptions);
  };

  const buttonStyle = {
    backgroundColor: colors.background,
    opacity: isPressed ? 0.6 : 1,
    cursor: isPressed ? "default" : "pointer",
  };
  return (
    <div className="feedback-buttons-container">
      <div
        className="feedback-button"
        style={buttonStyle}
        onClick={() => (isPressed ? {} : buttonPress({ helpfull: true }))}
      >
        <img
          alt="Happy"
          src={isDarkMode ? HappyIconDark : HappyIconLight}
          draggable={false}
        />
        <span className="feedback-text" style={{ color: colors.primaryText }}>
          {strings.helpful_text}
        </span>
      </div>
      <div
        className="feedback-button"
        style={buttonStyle}
        onClick={() => (isPressed ? {} : buttonPress({ helpfull: false }))}
      >
        <img
          alt="Unhappy"
          src={isDarkMode ? UnhappyIconDark : UnhappyIconLight}
          draggable={false}
        />
        <span className="feedback-text" style={{ color: colors.primaryText }}>
          {strings.not_helpful_text}
        </span>
      </div>
    </div>
  );
};
export default FeedbackButtons;
